import React from 'react'
import { commonFilterFn, getRandomKey } from '../../../../../services/lib/utils/helpers'
import { Button, Popover, Switch, Tooltip } from 'antd'
import ItipsForProduct from '../../../../../components/common/i-tips/product'
import moment from 'moment'
import { AlertOutlined } from '@ant-design/icons'
import { EditOutlined } from '@material-ui/icons'

const qtyLabelStyle: React.CSSProperties = {
  color: '#8c8c8c',
  fontSize: '0.72rem',
  marginRight: 2,
}

const qtyValueStyle: React.CSSProperties = {
  fontWeight: 600,
}

const qtyItemStyle: React.CSSProperties = {
  whiteSpace: 'nowrap',
}

const dateLabelStyle: React.CSSProperties = {
  color: '#8c8c8c',
  fontSize: '0.72rem',
  marginRight: 4,
}

const dateValueStyle: React.CSSProperties = {
  fontWeight: 600,
  color: '#1a3d2e',
}

const dateItemStyle: React.CSSProperties = {
  whiteSpace: 'nowrap',
}

// Product cell: wrap at ~35 chars per line, break at word boundaries only, full info on hover
const productCellWrapStyle: any = {
  // wordBreak: 'normal',
  // overflowWrap: 'break-word',
  // lineHeight: '1.3em',
  cursor: 'pointer',
}

export const myfiler=(
  filterValue:any,
  rowData:any
) => {
  const filter = filterValue.replace(/-/g, '\u2011').trim().slice(0,-1);
  for (let ele of rowData){
    const prodName = ele.product?.productName.replace(/-/g, '\u2011').trim();
    if (prodName.indexOf(filter) >=0) return true;
  }
  return false;
}  
const WorkOrderManagementColumnModel = (props: any) => {
  const barcodeFilterFn = (inputValue: any, rowData: any) => {
    const filter = inputValue.trim().toLowerCase();
    return rowData.boxInfo?.some((box: any) => box.barCode.toLowerCase().includes(filter)) || false;
  };  
  return [
    {
      title: 'Work Order No.',
      field: 'serialNumber',
      // defaultSort: 'asc'
    },    
    {
      title: 'Product Code',
      field: 'productCode',
      // defaultSort: 'asc'
      customFilterAndSearch: (inputValue: any, rowData: any) => commonFilterFn(inputValue.replace(/^\s*|\s*$/g,""), rowData.productCode?.replace(/^\s*|\s*$/g,""))
    },
    {
      title: 'Product',
      field: 'productFilter',
      sorting: false,
      width: 260,
      customFilterAndSearch: (inputValue: any, rowData: any) => commonFilterFn(inputValue.replace(/^\s*|\s*$/g,""), rowData.product?.productName?.replace(/^\s*|\s*$/g,"")),
      // customFilterAndSearch:(        filterValue:any,
      //   rowData:any) =>myfiler(
      //   filterValue,
      //   rowData
      // ),
      render: (rowData: any) => rowData.product ? (
        <div>
          <ItipsForProduct id={rowData.productId} label={rowData.product?.productName} isWrap wrapLength={40} />
        </div>
      ) : null
    },
    {
      title: 'Qty',
      field: 'quantity',
      render: (rowData: any) => {
        const canEditQty = rowData.workOrderStatusId === -1
        return (
          <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
            {rowData.quantity}
            {canEditQty && (
              <Tooltip title="Edit Quantity">
                <Button
                  size="small"
                  type="text"
                  style={{ display: 'inline-flex', alignItems: 'center', height: 'auto', padding: 0 }}
                  onClick={() => {
                    props.updateQuantity(rowData)
                  }}
                  icon={<EditOutlined style={{ fontSize: 14, color: '#1a3d2e' }} />}
                />
              </Tooltip>
            )}
          </div>
        )
      }
    },
    // {
    //   title: 'Order Type',
    //   field: 'orderType',
    //   sorting: false,
    //   lookup: { 1: 'Normal order', 2: 'Raw to semi', 3: 'Semi to products' },
    //   customFilterAndSearch: (term: any, rowData: any) => term && term.length ? term.includes(rowData.orderTypeId?.toString()) : true,
    //   render: (rowData: any) => rowData.orderType?.orderTypeName
    // },
    {
      title: 'Source',
      field: 'workOrderSource',
      sorting: false,
      lookup: { 1: 'Sales Order', 2: 'Manual', 3: 'Inventory', 4: 'Redo', 5: 'Makeup' },
      customFilterAndSearch: (term: any, rowData: any) => term && term.length ? term.includes(rowData.workOrderSourceId?.toString()) : true,
      render: (rowData: any) => rowData.workOrderSource?.workOrderSourceName
    },
    {
      title: 'Created By',
      field: 'createdEmployeeName',
    },
    {
      title: 'Status',
      field: 'workOrderStatusId1',
      sorting: false,
      defaultFilter: ['-1', '1', '2'],
      lookup: { '-1': 'New', 1: 'Appr', 10: 'Comp', 0: 'Canc' },
      customFilterAndSearch: (term: any, rowData: any) => term && term.length ? term.includes(rowData.workOrderStatusId1?.toString()) : true,
      render: (rowData: any) => {
        // console.log(rowData)
        let name = rowData.workOrderStatus?.workOrderStatusName
        if (rowData.workOrderStatusId==2) 
          name = "Approved"
        // Awaiting Approval: status text is hidden since the Approve button already indicates it
        const isAwaitingApproval = rowData.workOrderStatusId === -1
        return (
          <div>
            {!isAwaitingApproval && name}
            {
              isAwaitingApproval ? (
                <div key={getRandomKey()}>
                  <Button danger
                    type="primary"
                    onClick={() => {
                      props.updateApproveStatus(rowData)
                    }}
                  >Approve</Button>
                </div>
              ) : null
            }
          </div>
        )
      }
    },
    {
      title: 'Action / Routing',
      field: 'actionId',
      sorting: false,
      lookup: { 1: 'Printing', 2: 'Die-Cutting', 3: 'Production', 4: 'Packaging' },
      render: (rowData: any) => {
        const routing = rowData.routingDto
        let routingCell: any = <span style={{ color: '#999' }}>-</span>
        if (routing) {
          const steps = routing.steps || []
          const content = (
            <div style={{ maxWidth: 340 }}>
              {steps.length ? (
                steps.map((step: any, index: number) => (
                  <div
                    key={step.sequenceNo ?? index}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 8,
                      padding: '3px 0',
                      fontSize: 12,
                      borderTop: index ? '1px solid #f0f0f0' : 'none'
                    }}
                  >
                    <span style={{ color: '#8c8c8c', width: 16 }}>{step.sequenceNo}</span>
                    <span style={{ fontWeight: 600, width: 64 }}>{step.actionName}</span>
                    <span style={{ flex: 1 }}>
                      {step.machineName || '-'}
                    </span>
                  </div>
                ))
              ) : (
                <div style={{ fontSize: 12, color: '#999' }}>No routing steps</div>
              )}
            </div>
          )
          routingCell = (
            <Popover
              content={content}
              title={
                <span>
                  Routing: {routing.productTypeName || '-'}
                  {routing.isDefault ? (
                    <span style={{ color: '#52c41a', marginLeft: 6, fontSize: 12 }}>(Default)</span>
                  ) : null}
                </span>
              }
              trigger="hover"
              placement="left"
            >
              <span style={{ cursor: 'pointer', borderBottom: '1px dotted #999' }}>
                {routing.productTypeName || '-'}
              </span>
            </Popover>
          )
        }
        return (
          <div>
            <div style={{ fontWeight: 500 }}>{rowData.actionDto?.actionName || '-'}</div>
            <div style={{ fontSize: 12 }}>{routingCell}</div>
          </div>
        )
      }
    },
    {
      title: 'Created At',
      field: 'createdAt1',
      // render: (rowData: any) => moment.utc(rowData.createdAt1).local().format('DD/MM/YYYY'),
      render: (rowData: any) =>moment.utc(rowData.createdAt1).local().format('DD/MM/YYYY HH:mm:ss'),
    },
    {
      title: 'REQ Date',
      field: 'requiredDate1',
      render: (rowData: any) => moment.utc(rowData.requiredDate1).local().format('DD/MM/YYYY'),
    },
    {
      title: 'Urgent',
      field: 'urgent',
      initialEditValue: 0,
      align: 'left',
      sorting: false,
      type: 'numeric',
      lookup: {0: 'No', 1: 'Yes'},
      render: (rowData: any) => {
        return (
          <div>
            {
              rowData.urgent == 1 && 
                <div>
                <Popover
                  content={rowData.urgentNote}
                  title={<div style={{ textAlign: 'center' }}>Urgent</div>}>
                  <AlertOutlined style={{ textAlign: 'center' ,fontSize: '24px', color: 'red' }} />
                </Popover>
                </div>
            }            
            {
              ![10, 0].includes(rowData.workOrderStatusId) ? (
                <div key={getRandomKey()}>
                  <Tooltip title={rowData.urgent == 1 ? 'Unset Urgent' : 'Set Urgent'}>
        <Switch
          size="small"
          checked={rowData.urgent == 1}
          onChange={() => {
            props.updateUrgent(rowData)
          }}
        />
      </Tooltip>
                </div>
              ) : null
            }
          </div>
        )
      }
    },
    {
      title: 'Comments',
      field: 'comments',
      render: (rowData: any) => {
        const commentText = rowData.comments || ''
        const isSpecial = rowData.commentType === 'Special'
        // null / 'null' 字符串 / 纯空格都视为无备注：不显示占位符，仅保留编辑入口
        const hasComment = typeof rowData.comments === 'string'
          ? rowData.comments.trim() !== '' && rowData.comments !== 'null'
          : !!rowData.comments
        return (
          <div style={{
            color: hasComment ? (isSpecial ? 'red' : '#595959') : '#c0c0c0',
            fontWeight: isSpecial ? 600 : 400,
            fontStyle: hasComment ? 'normal' : 'italic',
            lineHeight: '1.3em',
            wordBreak: 'normal',
            overflowWrap: 'break-word'
          }}>
            {hasComment && (
              <Tooltip title={commentText}>
                <span style={{ cursor: 'pointer' }}>
                  {commentText}
                </span>
              </Tooltip>
            )}
            <Tooltip title="Change Comments">
            <Button
              size="small"
              type="text"
              style={{ display: 'inline-flex', alignItems: 'center', height: 'auto', padding: 0, marginLeft: 2, verticalAlign: 'middle' }}
              onClick={() => {
                props.updateStatusComments(rowData)
              }}
              
              icon={<EditOutlined style={{ fontSize: 15, color: hasComment ? '#1a3d2e' : '#bfbfbf' }} />}
            />
            </Tooltip>
          </div>
        )
      }
    },
    {
      title: 'Production Note',
      field: 'rawMaterialNote',
    },    
  ]
}


/**
 * Normalizes the ProductionOperator returned by WorkOrder/GetTrackingInfo
 * into a display label. Handles both a plain string and an employee object.
 */
export const productionOperatorLabel = (productionOperator: any) => {
  if (!productionOperator) {
    return ''
  }
  const label = typeof productionOperator === 'string'
    ? productionOperator
    : [productionOperator.firstName, productionOperator.lastName]
    .filter(Boolean)
    .join(' ')
    .trim()
  return label ? label.charAt(0).toUpperCase() + label.slice(1) : label
}

const TraceabilityColumnModel = (props: any) => {
  // Custom filter and search function for barcode
  const barcodeFilterFn = (inputValue: any, rowData: any) => {
    const filter = inputValue.trim().toLowerCase();
    return rowData.boxInfo?.some((box: any) => box.barCode.toLowerCase().includes(filter)) || false;
  };  
  return [
    {
      title: 'WO No.',
      field: 'serialNumber',
      // defaultSort: 'asc'
    },    
    {
      title: 'Product Code',
      field: 'productCode',
      // defaultSort: 'asc'
      customFilterAndSearch: (inputValue: any, rowData: any) => commonFilterFn(inputValue.replace(/^\s*|\s*$/g,""), rowData.productCode?.replace(/^\s*|\s*$/g,""))
    },
    {
      title: 'Product',
      field: 'productName',
      sorting: false,
      width: 260,
      // Discontinued products are missing from GetAllProductName, so row.product
      // can be null - fall back to the row's own productName for filtering.
      customFilterAndSearch: (inputValue: any, rowData: any) => commonFilterFn(inputValue.replace(/^\s*|\s*$/g,""), (rowData.product?.productName || rowData.productName)?.replace(/^\s*|\s*$/g,"")),
      // customFilterAndSearch:(        filterValue:any,
      //   rowData:any) =>myfiler(
      //   filterValue,
      //   rowData
      // ),
      render: (rowData: any) => rowData.productName ? (
        <div style={productCellWrapStyle}>
          <ItipsForProduct id={rowData.productId} label={rowData.productName} isWrap wrapLength={35} />
        </div>
      ) : null
    },
    {
      title: 'Order Status',
      field: 'status',
    },    
    {
      title: 'Qty',
      field: 'quantityOrder',
      customFilterAndSearch: (inputValue: any, rowData: any) => {
        const value = String(inputValue).trim()
        return [
          rowData.quantityOrder,
          rowData.quantityInStock,
          rowData.quantityMade,
          rowData.quantityDispatched,
          rowData.quantityHold,
        ].some((quantity) => String(quantity ?? 0).includes(value))
      },
      render: (rowData: any) => (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, max-content)', gap: '2px 14px', lineHeight: 1.5 }}>
          <div style={qtyItemStyle}><span style={qtyLabelStyle}>Ord</span> <span style={{ ...qtyValueStyle, color: '#1a3d2e' }}>{rowData.quantityOrder ?? 0}</span></div>
          <div style={qtyItemStyle}><span style={qtyLabelStyle}>Stk</span> <span style={{ ...qtyValueStyle, color: '#52c41a' }}>{rowData.quantityInStock ?? 0}</span></div>
          <div style={qtyItemStyle}><span style={qtyLabelStyle}>Mfd</span> <span style={{ ...qtyValueStyle, color: '#1890ff' }}>{rowData.quantityMade ?? 0}</span></div>
          <div style={qtyItemStyle}><span style={qtyLabelStyle}>Disp</span> <span style={{ ...qtyValueStyle, color: '#722ed1' }}>{rowData.quantityDispatched ?? 0}</span></div>
          <div style={qtyItemStyle}><span style={qtyLabelStyle}>Hold</span> <span style={{ ...qtyValueStyle, color: '#fa541c' }}>{rowData.quantityHold ?? 0}</span></div>
        </div>
      ),
    },
    {
      title: 'Box Info',
      field: 'boxInfo',
      customFilterAndSearch: barcodeFilterFn,

      // render: (rowData: any) =><ItipsForProduct id={rowData.productId} label={rowData.productName} />
      render: (rowData: any) => (
        <div>
          <Popover
            content={
              rowData.boxInfo?.map((row: any, index: any) => (
                <div key={index}>
                  <b>Barcode:</b>&nbsp;{row?.barCode}&nbsp;
                  <b>Quantity:</b>&nbsp;{row?.quantity}&nbsp;
                  <b>Localtion:</b>&nbsp;{row?.status}&nbsp;
                </div>
              ))
            }
            title="Details"
          >
            <Button type="primary" ghost>Quantity: {rowData?.boxInfo?.length}</Button>
          </Popover>
          {}
        </div>
      )      
    },

    {
      title: 'Created At',
      field: 'createdAt1',
      customFilterAndSearch: (inputValue: any, rowData: any) => {
        const value = (inputValue ?? '').toString().trim()
        if (!value) return true
        const created = moment.utc(rowData.createdAt1).local().format('DD/MM/YYYY')
        return created.includes(value)
      },
      render: (rowData: any) => (
        <span style={dateValueStyle}>
          {rowData.createdAt1 ? moment.utc(rowData.createdAt1).local().format('DD/MM/YYYY') : ''}
        </span>
      ),
    },
    {
      title: 'Manufacture Date',
      field: 'madedAt',
      customFilterAndSearch: (inputValue: any, rowData: any) => {
        const value = (inputValue ?? '').toString().trim()
        if (!value) return true
        if (!rowData.madedAt) return false
        const maded = moment.utc(rowData.madedAt).local().format('DD/MM/YYYY')
        return maded.includes(value)
      },
      render: (rowData: any) => (
        rowData.madedAt
          ? <span style={dateValueStyle}>{moment.utc(rowData.madedAt).local().format('DD/MM/YYYY')}</span>
          : ''
      ),
    },

    {
      title: 'Production Operator',
      field: 'productionOperator',
      customFilterAndSearch: (inputValue: any, rowData: any) =>
        commonFilterFn(inputValue.replace(/^\s*|\s*$/g, ""), productionOperatorLabel(rowData.productionOperator)),
      render: (rowData: any) => productionOperatorLabel(rowData.productionOperator),
    },
    {
      title: 'RM Batch',
      field: 'rawMaterialNote',
      render: (rowData: any) => {
        return (
          <div>
            <div>{rowData.rawMaterialNote}</div>
            <div>
            {
              <Button
                type={'primary'}
                onClick={() => {
                  props.updateRMNote(rowData)
                }}
              >Update Notes</Button>
            }              
            </div>
          </div>
        )
      }      
    },    
  ]
}

export default WorkOrderManagementColumnModel
export { TraceabilityColumnModel };
